const _excluded = ["steps", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { Button, TextButton, useOverlayContext } from 'seagull';
import Modal from "./Modal";
import { jsx as _jsx } from "react/jsx-runtime";
export default function SeeWhatItsLike(_ref) {
  let {
      steps,
      as = 'button'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const overlayContext = useOverlayContext();
  const tid = props['data-testid'];
  const testPrefix = "".concat(tid ? tid + '-' : '', "see-what-it-is-like");
  const handleOnClick = () => {
    return overlayContext.showModal({
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(Modal, {
          steps: steps,
          onClose: dismissModal,
          testPrefix: testPrefix
        });
      },
      closeOnClickOutside: true,
      closeOnEscapeKey: true
    });
  };
  if (as === 'button') {
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      skin: "primaryOutline"
    }, props), {}, {
      "data-testid": testPrefix,
      onClick: handleOnClick,
      children: "See what it\u2019s like"
    }));
  } else {
    return /*#__PURE__*/_jsx(TextButton, _objectSpread(_objectSpread({}, props), {}, {
      "data-testid": testPrefix,
      onClick: handleOnClick,
      children: "See what it\u2019s like"
    }));
  }
}